import { IUserToken } from '@module/authentication/models';
import { IRequestReportRequest, IRequestReportResponse } from '@module/shared';

export async function FetchRequestLog(loggedInUser: IUserToken, request: IRequestReportRequest): Promise<IRequestReportResponse> {    
    const filter = `RequestId=${request.requestFilter.requestID}&CompanyName=${request.requestFilter.companyName}&CountryName=${request.requestFilter.countryName}&Status=${request.requestFilter.status}&PartsSpecialistName=${request.requestFilter.partsSpecialistName}`;
    const url = `${environmentSettings.webapiUrl}/v1/Request?${filter}&SortField=${request.sortField}&SortDirection=${request.sortDirection}&PageSize=${request.pageSize}&CurrentPage=${request.currentPage}`;
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + loggedInUser.access_token);
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    const response = await fetch(encodeURI(url), { headers, cache: 'no-store' });
    if (response.ok) {
      const requestLog: IRequestReportResponse = await response.json();
      return requestLog;
    } else {      
      return Promise.reject({status: response.status, statusText: response.statusText});
    }
  }
  // tslint:disable-next-line:eofline
  